import React, { useState } from 'react';
import { Icon } from 'semantic-ui-react';
import toastr from 'toastr';

export default function CopyComponent({ textToCopy, floatPosition = 'none' }) {
  const [copyclicked, handleCopyClick] = useState(false);
  const handleClickToCopy = () => {
    navigator.clipboard.writeText(textToCopy).then(
      () => {
        toastr.success('Copied!');
        handleCopyClick(true);
      },
      () => {
        toastr.error('Copy failed!');
      }
    );
    setTimeout(() => {
      handleCopyClick(false);
    }, 5000);
  };
  return (
    <span className="p-cursor" onClick={handleClickToCopy} style={{ float: floatPosition }}>
      {copyclicked ? (
        <Icon name="check circle" style={{ fontSize: 'inherit', color: 'green' }} />
      ) : (
        <Icon name="copy outline" style={{ fontSize: 'inherit' }} />
      )}
    </span>
  );
}
